import type { Instrument } from '../services/api';

export interface InstrumentAccessContact {
  name: string;
  role: string;
  phone?: string;
  email?: string;
}

export const parseMemberNames = (value?: string): string[] => {
  if (!value) return [];
  return value
    .split(/[、,，;\s]+/)
    .map((item) => item.trim())
    .filter(Boolean);
};

export function isUserInAllowedList(
  allowedUsers: string | undefined,
  name?: string | null,
  username?: string | null
): boolean {
  const parts = parseMemberNames(allowedUsers);
  if (!parts.length) return true;
  if (!name && !username) return false;
  return Boolean((name && parts.includes(name)) || (username && parts.includes(username)));
}

export function canCurrentUserReserveInstrument(
  instrument: Instrument | null | undefined,
  opts: { role?: string | null; name?: string | null; username?: string | null }
): boolean {
  if (!instrument) return false;
  const { role, name, username } = opts;
  if (role === '超级管理员' || role === '管理员') return true;
  const responsible = parseMemberNames(instrument.responsiblePerson);
  if (
    responsible.length &&
    ((name && responsible.includes(name)) || (username && responsible.includes(username)))
  ) {
    return true;
  }
  return isUserInAllowedList(instrument.allowedUsers, name, username);
}

export function formatInstrumentAccessDeniedMessage(
  error?: string,
  contacts?: InstrumentAccessContact[]
): string {
  if (error) return error;
  if (!contacts?.length) {
    return '您不在该仪器的可用成员名单中，暂时无法预约。请联系仪器负责人或团队管理员申请开通权限。';
  }
  const lines = contacts.map((c) => {
    const bits = [`${c.name}（${c.role}）`];
    if (c.phone) bits.push(`电话 ${c.phone}`);
    if (c.email) bits.push(`邮箱 ${c.email}`);
    return bits.join('，');
  });
  return `您不在该仪器的可用成员名单中，暂时无法预约。如需开通权限，请联系：${lines.join('；')}`;
}
